export default '/build/0e7334ba.svg'